import type { WorkflowStore } from "./index";

export const selectSelectedStep = (s: WorkflowStore) =>
    s.steps.find((step) => step.id === s.selectedNodeId) ?? null;

export const selectSelectedStepIndex = (s: WorkflowStore) =>
    s.steps.findIndex((step) => step.id === s.selectedNodeId);

export const selectHasChanged = (s: WorkflowStore): boolean => {
    const current = JSON.stringify({
        steps: s.steps,
        workflowName: s.workflowName,
        applyOncePerContact: s.applyOncePerContact,
    });
    return s.originalSnapshot === null || current !== s.originalSnapshot;
};
